"use client";

import { usePathname } from "@/i18n/routing";
import React, { useEffect, useState } from "react";
import { useShouldShowAds } from "./AdsProvider";

type Props = {
  children: React.ReactNode;
};

const AdWrapper: React.FC<Props> = ({ children }) => {
  const [shouldMount, setShouldMount] = useState(true);
  const shouldShowAds = useShouldShowAds();
  const pathname = usePathname();

  useEffect(() => {
    setShouldMount(true);

    return () => {
      setShouldMount(false);
    };
  }, [pathname]);

  return shouldShowAds && shouldMount ? children : null;
};

export default AdWrapper;
